"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KinnserHospice = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class KinnserHospice {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : KINNSER HOSPICE Software Parser
     * ********************************************************************************************************************/
    /**
     * @function parse
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary KinnserHospiceSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            //**Session 1 Patient name*/
            const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Patient Information", "Allergies");
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(sessionFirst);
            //**Session 3 Insurance*/
            const sessionThird = (0, helper_1.substrInBetween)(pastedData, "Internal Referral", "Insurance ID No");
            const insurance = this.getInsurance(sessionThird);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact Information:", "Emergency Contact 2:");
            //**Session 7 Primary Physician*/
            const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Physician Information", "Current Benefit Period (2)");
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Pharmacy Information", "Emergency Contact Information");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            //**Session 9 Comments*/
            const sessionNine = (0, helper_1.substrInBetween)(pastedData, "Comments", "Physician Information");
            const comment = this.getComment(sessionNine);
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo), comment);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kinnserHospice
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        sessionFirst = sessionFirst.substr(0, sessionFirst.indexOf("Branch"));
        let dob = (0, helper_1.substrInBetween)(sessionFirst, "Date of Birth", "Gender");
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)(sessionFirst), dob: (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from kinnserHospice
     */
    getInsurance(sessionThird) {
        if (!sessionThird) {
            return {};
        }
        const insurance = sessionThird.replace("Insurance", "");
        //Primary Insurance and Secondary Insurance
        return { insurance: (0, helper_1.trim)(insurance) };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from kinnserHospice
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: [this.getCaregiver(sessionSix)],
            },
        };
        const phyInfo = this.getPatPhyCareDetails(sessionSeven.substr(0, sessionSeven.indexOf("Fax")), "Name");
        primaryPhy.info.physician[0].name = phyInfo.name;
        primaryPhy.info.physician[0].phoneNo = phyInfo.phoneNo;
        //@Return
        return primaryPhy;
    }
    getPhyCareName(data, findName) {
        let name = "";
        for (const txt of data) {
            if (txt.indexOf(findName) != -1) {
                name = (0, helper_1.trim)(txt.replace(findName, ""));
                break;
            }
        }
        //Return name
        return name;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        const phyInfo = this.getPatPhyCareDetails(data, "1	Pharmacy");
        pharmacyData.name = phyInfo.name;
        pharmacyData.phoneNo = phyInfo.phoneNo;
        //@Return
        return pharmacyData;
    }
    getPatPhyCareDetails(data, breakName) {
        const info = {
            name: "",
            phoneNo: "",
        };
        //Blank data Return
        if (!data) {
            return info;
        }
        const breakPhyData = data.split(/\n/g);
        for (const phyInfo of breakPhyData) {
            if (phyInfo.indexOf(breakName) !== -1) {
                info.name = (0, helper_1.trim)(phyInfo.replace(breakName, ""));
            }
            if (phyInfo.indexOf("Phone") !== -1) {
                let pNumber = phyInfo.replace("Phone", "");
                pNumber = pNumber.replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(pNumber);
                break; //Break Loop
            }
        }
        //@Return
        return info;
    }
    getCaregiver(data) {
        const caregiverData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        if (!data) {
            return caregiverData;
        }
        //Find name
        const nameInArray = data.split(/\n/g);
        //Primary Physician name
        caregiverData.name = `${this.getPhyCareName(nameInArray, "Emergency Contact 1:")}`;
        //**Update String for Number of Address*/
        const numberString = (0, helper_1.substrInBetween)(data, "Emergency Contact Telephone No:", "Relationship:");
        if (numberString) {
            const number = (0, helper_1.trim)(numberString.replace(/[\s-()]/g, ""));
            caregiverData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //Bind name with Relationship
        if (caregiverData.name) {
            const relationship = (0, helper_1.substrInBetween)(data, "Relationship:", "Emergency Contact Address:");
            if (relationship) {
                caregiverData.name += ` (${relationship})`;
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        let pAddress = (0, helper_1.substrInBetween)(firstSession, "Address", "Apt/Room");
        let pNumber = (0, helper_1.substrInBetween)(firstSession, "Phone", "Email");
        //address
        if (pAddress) {
            pAddress = pAddress.replace(/[\n]/g, " ");
            info.address.placeName = pAddress;
        }
        //number
        if (pNumber) {
            pNumber = (0, helper_1.trim)(pNumber).replace(/[\s-()]/g, "");
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(pNumber);
        }
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const findPatientName = sessionFirst.split(/\n/g);
        for (const pName of findPatientName) {
            //First name
            if (pName.indexOf("First Name") !== -1) {
                const FName = pName.replace("First Name", "");
                //First name not found
                if (!FName) {
                    return;
                }
                name.firstName = (0, helper_1.trim)(FName);
            }
            //Middle Name<space>Last Name
            if (pName.indexOf("Middle Name") !== -1) {
                const MName = pName.replace("Middle Name", "");
                //Middle name not found
                if (!MName) {
                    return;
                }
                //Middle name <space>
                name.lastName = `${(0, helper_1.trim)(MName)} `;
            }
            //Last Name: If find last name loop break
            if (pName.indexOf("Last Name") !== -1) {
                const LName = pName.replace("Last Name", "");
                //Last name not found
                if (!LName) {
                    return;
                }
                name.lastName += (0, helper_1.trim)(LName);
                break; //Break loop
            }
        }
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from kinnser
     */
    getComment(comment) {
        if (comment && (0, helper_1.arrayLength)(comment) < 100) {
            return { about: comment };
        }
    }
}
exports.KinnserHospice = KinnserHospice;
